/**
 * Created by unkingbk on 13.12.17.
 */
$(document).ready(function () {
	var btn = $('.sidebar-toggle');

	btn.on('click',function (evt) {
		var sidebar = $('.main-sidebar');
		sidebar.toggleClass('open');
	})
});